<template>
  <div id="main">
    <mv-full-page
      :isPointer="false"
      :isV="isV"
      :pages="pageCount"
      :page.sync="currentPage"
      :isCache="true"
      height="calc(100% - 0.72rem)"
      :transition="{
        duration: '500ms', // 动画时长
        timingFun: 'ease', // 动画速度曲线
        delay: '0s', // 动画延迟
      }"
      @rollEnd="onRollEnd"
      :config="{
        disabled: this.localValue
      }"
    >
      <template #page1>
        <div class="video">
          <div class="video-container">
            <video class="video" ref="myVideo" :src="videoPath" muted autoplay loop
                   @contextmenu.prevent
                   controls playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
                   :poster="videoPath + '?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'">
            </video>
          </div>
          <div class="copyright"></div>
        </div>
      </template>
      <template #page2>
        <div class="therapeuticInstrument">
          <img alt :src="require('@/assets/img/product/t20/diease.png')"/>
          <div class="about">
            <img :src="require('@/assets/img/product/t20/diease-left-name.png')" alt="">
            <p>双重治疗修复<br/>双效提升健康状态</p>
            <p>盆底康复+私密抗衰</p>
          </div>
          <div class="img-copyright">
            广告审查批准文号:苏械广审(文)第270509-08266号  盆底康复治疗仪  医疗器械注册号:苏械注准20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书  南京麦豆健康科技有限公司
          </div>
        </div>
      </template>
    </mv-full-page>
  </div>
</template>

<script>
import '@/assets/css/animate.min.css';
import 'mv-full-page/lib-dist/mv-full-page.css';
import MvFullPage from 'mv-full-page';
import Vue from 'vue';
import directives from '@/utils/directives';

Vue.use(directives);
Vue.use(MvFullPage);

export default {
  data() {
    return {
      localValue: this.value,
      isV: true,
      currentPage: 1,
      pageCount: 2,
      videoPath: `//download.wrightin.com/website/product-t20.mp4`,
    };
  },
  props: {
    value: { //数据源（必填）
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$parent.$emit('rollInit');
  },
  methods: {
    onRollEnd(page) {
      this.$parent.$emit('rollPage', page);
      if (page === this.pageCount) {
        this.$parent.$emit('rollEnd');
      } else {
        this.$parent.$emit('rollTop');
      }
    },
  },
  watch: {
    value(val) {
      this.localValue = val;
    },
    currentPage(val) {
      if (val === 1) {
        this.localValue = false;
      }
    },
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.full-page-wrapper {
  top: 0.72rem;

  // 强制第一页全屏
  /deep/ .all-page .page:nth-child(1) {
    height: calc(100% / 2 + 0.72rem) !important;
    margin-top: -0.72rem !important;
  }
}

.video {
  position: relative;
  width: 100%;
  height: 100%;

  > .video-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;

    > .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  >.copyright {
    position: absolute;
    bottom: 0.24rem;
    left: 0;
    width: 100%;
    font-weight: 400;
    font-size: 0.12rem;
    color: rgba(255, 255, 255, 0.64);
    line-height: 0.17rem;
    text-align: center;
    pointer-events: none;
  }
}

.disease {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #DEE1F7 0%, #AEB4F2 100%);
  padding: 1.96rem 0.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > p:nth-child(1) {
      font-weight: 500;
      font-size: 0.56rem;
      color: #000000;
      line-height: 0.78rem;
    }

    > p:nth-child(2) {
      margin-top: 0.12rem;
      font-weight: 500;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.39rem;
    }

    > img {
      margin-top: 0.6rem;
      width: 7.66rem;
    }
  }

  > .right {
    width: 8.25rem;
  }
}

.therapeuticInstrument {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #DEE1F7 0%, #AEB4F2 100%);
  display: flex;
  align-items: center;
  > img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  // 悬浮放大
  //> img:hover {
  //  transform: scale(1.2);
  //}

  > .about {

    left: 3.06rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    > img{
      width: 2.81rem;
      height: 0.65rem;
    }
    > p:nth-child(2) {
      margin-top: 0.18rem;
      text-align: center;
      font-size: 0.56rem;
      color: #000000;
      font-weight: 500;
      line-height: 0.78rem;
    }

    > p:nth-child(3) {
      line-height: 0.45rem;
      font-weight: 500;
      margin-top: 0.12rem;
      font-size: 0.32rem;
      color: #000000;
    }
  }
}
</style>
